import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import EnquiryForm from "./EnquiryForm";

export default function CallbackDialog({ open, onOpenChange, product }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-lg" data-testid="callback-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-[#0A192F]">
            Request a Callback{product ? ` — ${product.name}` : ""}
          </DialogTitle>
        </DialogHeader>
        <EnquiryForm
          compact
          enquiry_type="callback"
          product_id={product?.id || null}
          cta="Request Callback"
          testIdPrefix="callback"
        />
      </DialogContent>
    </Dialog>
  );
}
